import { DownloadIcon } from '~components/icons/DownloadIcon';
import { SpinnerIcon } from '~components/icons/SpinnerIcon';
import { Button } from '~modules/media-library/view/Button';

type DownloadButtonProps = {
  onClick: () => void;
  isProcessing?: boolean;
};

export function DownloadButton({ onClick, isProcessing = false }: DownloadButtonProps) {
  if (!onClick) {
    return null;
  }

  return (
    <Button onClick={onClick} disabled={isProcessing} className="ml-icon-download">
      Crop {isProcessing ? <SpinnerIcon className="animate-spin w-4 h-4 px-1" /> : <DownloadIcon className="px-1" />}
    </Button>
  );
}
